import React, { useCallback, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { setPuzzleAndPuzzleType } from "Store/features/puzzleSlice";
import "./Quiz.css";
import { makeSavePuzzleRequest } from "API/Puzzles";
import QuizScreen from "./QuizScreen";

const Quiz = (props) => {
  const { onClickBack, draftPuzzle, puzzleTitle } = props;
  const dispatch = useDispatch();

  const puzzleSlice = useSelector((state) => state.puzzleSlice);
  const puzzleId = useSelector((state) => state.puzzleSlice?.puzzleId);
  const puzzle = useSelector((state) => state.puzzleSlice?.puzzle);

  const authToken = useSelector((state) => state.authSlice?.authToken);

  const questions = draftPuzzle?.questions;
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const showScore = useSelector(
    (state) => state.puzzleSlice?.puzzle?.showScore
  );
  const score = useSelector((state) => state.puzzleSlice?.puzzle?.score);

  const [editQuizValue, setEditQuizValue] = useState("");
  const [editorSelectedOption, setEditorSelectedOption] = useState(null);

  const [editorQuestionText, setEditorQuestionText] = useState("");

  const handleSaveQuiz = useCallback(async () => {
    // const draftPuzzle = {
    //   ...puzzle,
    // };
    const savePuzzleParam = {
      id: puzzleId,
      puzzle: draftPuzzle,
      puzzleType: "quiz",
      title: puzzleTitle,
    };

    await makeSavePuzzleRequest(dispatch, authToken, savePuzzleParam);
  }, [dispatch, authToken, puzzle, puzzleId, puzzleTitle, draftPuzzle]);

  const handleAnswerOptionClick = useCallback(
    (index) => {
      setEditorSelectedOption(index);
      setEditQuizValue(questions[currentQuestion]?.options[index]?.answerText);
    },
    [questions, currentQuestion, score]
  );

  const handleQuestionTextClick = useCallback(
    (index) => {
      setEditorQuestionText(questions[currentQuestion]?.questionText);
    },
    [questions, currentQuestion, score]
  );

  const handleSaveEditOption = useCallback(
    (questions) => {
      dispatch(
        setPuzzleAndPuzzleType({
          ...puzzleSlice,
          puzzle: {
            ...puzzle,
            questions,
          },
        })
      );    
      setEditQuizValue("");
      setEditorSelectedOption(null);
    },
    [questions, puzzle, currentQuestion, editQuizValue]
  );

  
  const incrementCurrentQuestion = useCallback(() => {
    setCurrentQuestion(currentQuestion + 1);
    setEditQuizValue("");
    setEditorSelectedOption(null);
  }, [currentQuestion, setEditQuizValue, setEditorSelectedOption]);

  const decrementCurrentQuestion = useCallback(() => {
    setCurrentQuestion(currentQuestion - 1);
    setEditQuizValue("");
    setEditorSelectedOption(null);
  }, [currentQuestion, setEditQuizValue, setEditorSelectedOption]);

  const handleSaveQuestionText = useCallback(
    (questionText) => {
      const newQuestions = questions.map((question, questionIndex) => {
        if (questionIndex === currentQuestion) {
          return {
            questionText,
            options: question.options,
          };
        }
        return question;
      });
      dispatch(
        setPuzzleAndPuzzleType({
          ...puzzleSlice,
          puzzle: {
            ...puzzle,
            questions: newQuestions,
          },
        })
      );
      setEditorQuestionText("");
    },
    [questions, currentQuestion, puzzle]
  );

  const handleChangeQuestions = useCallback(
    (newQuestions) => {
      dispatch(
        setPuzzleAndPuzzleType({
          ...puzzleSlice,
          puzzle: {
            ...puzzle,
            questions: newQuestions,
          },
        })
      );
    },
    [questions, puzzle]
  );

  return (
    <>
      <div className="create-games-topbar-container">
        <div className="create-games-topbar-back-button" onClick={onClickBack}>
          <b>{"< "}</b>Back
        </div>{" "}
        <div
          className="create-games-topbar-continue-button"
          name="save-puzzle"
          onClick={handleSaveQuiz}
        >
          Save<b>{" >"}</b>
        </div>
      </div>
      <div className="quiz-editor-container">
        <div className="quiz-container">
          <QuizScreen
            questions={questions}
            currentQuestion={currentQuestion}
            score={score}
            setScore={score}
            showScore={showScore}
            setShowScore={showScore}
            handleAnswerOptionClick={handleAnswerOptionClick}
            incrementCurrentQuestion={incrementCurrentQuestion}
            decrementCurrentQuestion={decrementCurrentQuestion}
            editQuizValue={editQuizValue}
            setEditQuizValue={setEditQuizValue}
            editorSelectedOption={editorSelectedOption}
            setEditorSelectedOption={setEditorSelectedOption}   
            onSaveEditOption={handleSaveEditOption}
            editorQuestionText={editorQuestionText} 
            setEditorQuestionText={setEditorQuestionText}
            handleQuestionTextClick={handleQuestionTextClick}
            onSaveQuestionText={handleSaveQuestionText}
            onChangeQuestions={handleChangeQuestions}
          />
        </div>
      </div>
    </>
  );
};

export default Quiz;
